module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-table"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData.list || []
    }
  }, _vm._l((_vm.tableData.keyList), function(key) {
    return _c('el-table-column', {
      key: key,
      attrs: {
        "label": _vm.keyTxt[key] && _vm.keyTxt[key].txt,
        "prop": key,
        "width": _vm.keyTxt[key] && _vm.keyTxt[key].width
      }
    })
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-457edcce","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/card/table.vue
// module id = 940
// module chunks = 1